import dayjs from 'dayjs'
import { toRaw } from 'vue'
import { logService } from '@nsftx/seven-client-retail-utils'
import { useFetchBetslip } from '@nsftx/seven-client-retail-vue-sgp'
import { useTicketCheckStore } from '@/stores/ticket-check/ticketCheckStore'
import { useSpinnerStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useNotificationsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import i18n from '@/plugins/translationsPlugin'
import errorParser from '@/utils/errorParser'

const LOG_PREFIX = '[ticketCheckService]'
const TICKET_CHECK_ERROR_NOTIFICATION_ID = 'ticket_check_notification_error'
const TICKET_CHECK_DETAILS_DATE_FORMAT = 'DD/MM/YY HH:mm'
const { t } = i18n.global

const handleScannedTicket = async (barcode: string) => {
  const ticketCheckStore = useTicketCheckStore()
  const spinnerStore = useSpinnerStore()
  const notificationsStore = useNotificationsStore()
  const { betslip, fetchBetslip, error, errorDetails } = useFetchBetslip()

  logService.info(`${LOG_PREFIX} Ticket code scanned`, {
    ticket_code: barcode,
    code: 'ST_TICKET_CODE_SCAN'
  })

  notificationsStore.closeNotificationById(TICKET_CHECK_ERROR_NOTIFICATION_ID)
  spinnerStore.showSpinner()

  await fetchBetslip(barcode)

  spinnerStore.closeSpinner()

  if (betslip.value) {
    ticketCheckStore.ticketId = barcode
    ticketCheckStore.closeTicketCheckModal()
    ticketCheckStore.showTicketCheckDetailsModal()
  } else {
    logService.warn('[ticketCheckService] Failed to check ticket code', {
      ticket_code: barcode,
      code: 'ST_TICKET_CHECK_CODE_FORM_ERROR',
      ...errorParser.parseUpstream(error.value),
      details: toRaw(errorDetails.value)
    })
    notificationsStore.showNotification({
      id: TICKET_CHECK_ERROR_NOTIFICATION_ID,
      text: [t('ticket_check_error')],
      variant: 'error'
    })
  }
}

const getFormattedDate = (date: string) => dayjs(date).format(TICKET_CHECK_DETAILS_DATE_FORMAT)

export default { handleScannedTicket, getFormattedDate, TICKET_CHECK_ERROR_NOTIFICATION_ID }
